define('ItemSegmentation.Products.Base.View', [
    'Profile.Model',
    'ProductDetails.Base.View',
    'ItemSegmentation.Utils',
    'Backbone',
    'AjaxRequestsKiller',
    'underscore',
    'jQuery'
], function ItemSegmentationProductsBaseView(
    ProfileModel,
    ProductDetailsBaseView,
    ItemSegmentationUtils,
    Backbone,
    AjaxRequestsKiller,
    _,
    jQuery

) {
    'use strict';

    _.extend(ProductDetailsBaseView.prototype, {
        productDetails: function productDetails(apiQuery, options) {
            var application = this.application;
            var product = this.model;
            var promise = jQuery.Deferred();
            var item = product.get('item');
            var self = this;
            var profile = ProfileModel.getInstance();

            function getErrorCode(jqXhr) {
                return jqXhr && jqXhr.responseJSON && jqXhr.responseJSON.errorCode;
            }

            function rejectUnavailableItem(jqXhr, preventDefault) {
                var status = Number(jqXhr && jqXhr.status);
                var errorCode = getErrorCode(jqXhr);

                if (preventDefault && jqXhr) {
                    // Match the native PDP loader: this request owns its storefront
                    // error UI instead of letting the global GET handler duplicate it.
                    jqXhr.preventDefault = true;
                }

                if (status >= 500) {
                    application.getLayout().internalError();
                } else if (errorCode !== 'ERR_USER_SESSION_TIMED_OUT' &&
                    (status === 200 || status === 404)) {
                    application.getLayout().notFound();
                }

                // Always settle the view-level Deferred. NetSuite's global handler still
                // owns 401/206 session redirects before it checks preventDefault.
                promise.reject(jqXhr);
            }

            function isItemVisible(data) {
                var itemWebsiteValue;
                var itemWebsiteFacets;
                var storefrontDomains;
                var itemCustomerCategories;
                var isCustomerCategoryPermitted;
                var customerCategory;
                var customerCategoryFacetFilter;
                var responseItem;

                if (!data || !data.facets) {
                    return true;
                }

                itemWebsiteFacets = _.findWhere(data.facets, { id: 'custitem_awa_domains' });

                if (itemWebsiteFacets) {
                    storefrontDomains = ItemSegmentationUtils.getStorefrontDomains();
                    itemWebsiteValue = _.find(itemWebsiteFacets.values || [], function findVisibleDomain(value) {
                        return ItemSegmentationUtils.isDomainVisible(
                            value && value.label,
                            storefrontDomains
                        );
                    });

                    if (!itemWebsiteValue) {
                        return false;
                    }
                }

                // Customer-category segmentation applies only to signed-in shoppers.
                if (profile.get('isLoggedIn') !== 'T') {
                    return true;
                }

                customerCategory = _.findWhere(profile.get('customfields') || [], { name: 'custentity6' });
                if (!customerCategory || !customerCategory.value) {
                    return true;
                }

                customerCategoryFacetFilter = ItemSegmentationUtils.getCustomerCategoryFacetFilter(
                    customerCategory.value
                );
                if (!customerCategoryFacetFilter || !customerCategoryFacetFilter.text) {
                    return true;
                }

                responseItem = data.items && data.items[0];
                itemCustomerCategories = responseItem && responseItem.custitem_awa_customer_category;
                itemCustomerCategories = itemCustomerCategories && itemCustomerCategories !== '&nbsp;'
                    ? itemCustomerCategories.split(', ')
                    : [];
                isCustomerCategoryPermitted = _.any(
                    itemCustomerCategories,
                    function customerCategories(value) {
                        return value === customerCategoryFacetFilter.text;
                    }
                );

                return isCustomerCategoryPermitted;
            }

            item.fetch({
                data: apiQuery,
                killerId: AjaxRequestsKiller.getKillerId(),
                pageGeneratorPreload: true
            }).then(
                // Success function
                function successFunction(data, result, jqXhr) {
                    if (!item.isNew()) {
                        // once the item is fully loaded we set its options
                        product.setOptionsFromURL(options);
                        product.set('source', options && options.source);
                        product.set('internalid', options && options.internalid);
                        if (apiQuery.id && item.get('urlcomponent') && SC.ENVIRONMENT.jsEnvironment === 'server') {
                            nsglobal.statusCode = 301;
                            nsglobal.location = product.generateURL();
                        }

                        if (data && data.corrections && data.corrections.length > 0) {
                            if (item.get('urlcomponent') && SC.ENVIRONMENT.jsEnvironment === 'server') {
                                nsglobal.statusCode = 301;
                                var correctionUrl = data.corrections[0].url;
                                // A bare item slug must resolve from the site root, even
                                // when the requested URL ends in a trailing slash.
                                if (typeof correctionUrl === 'string' && correctionUrl &&
                                    correctionUrl.charAt(0) !== '/' &&
                                    !/^[a-z][a-z0-9+.-]*:/i.test(correctionUrl)) {
                                    correctionUrl = '/' + correctionUrl;
                                }
                                nsglobal.location = correctionUrl + product.getQuery();
                            } else {
                                Backbone.history.navigate('#' + data.corrections[0].url + product.getQuery(), { trigger: true });
                                promise.reject();
                                return;
                            }
                        }

                        if (!isItemVisible(data)) {
                            application.getLayout().notFound();
                            promise.reject();
                            return;
                        }

                        self.bindModel();
                        promise.resolve();
                    } else {
                        rejectUnavailableItem(jqXhr, false);
                    }
                },
                // Error function
                function errorFunction(jqXhr) {
                    rejectUnavailableItem(jqXhr, true);
                }
            ).fail(function rejectProcessingError(error) {
                promise.reject(error);
            });

            return promise;
        }
    });
});
